import { GeneralInfoContainer } from "../../Dashboard.styles";
import ActivatedAccountsWidget from "./ActivatedAccountsWidget";

const GeneralInfoData = () => {
  return (
    <GeneralInfoContainer>
      <ActivatedAccountsWidget />
    </GeneralInfoContainer>
  )
}

export default GeneralInfoData